import styled from "styled-components";

export const StyledContainer = styled.div`
  display: relative;
  width: 100%;
`;
export const StyledExplainWrapper = styled.div``;
